import Payment from '@pages/order/payment-shipping/Payment';
import Shipping from '@pages/order/payment-shipping/Shipping';
import Dispatch from '@pages/order/payment-shipping/Dispatch';



const PaymentShipping = () => {

	return (
		<div className='payment-shipping-section'>

			<Payment />
			
			<Shipping />

			<Dispatch />

		</div>
	);
};

export default PaymentShipping;